import React from "react";

const SectionTitle = ({ title1, title2, dotClassName,className }) => {
  return (
    <div className={`w-full flex gap-2 text-2xl mt-3 md:text-4xl font-black items-center pr-[50px] relative ${className}`}>
      <span className={`text-gray-200`}>{title1}</span>{" "}
      <span className="text-yellow-700">{title2}</span>

      <div className={`dottedSquare ${dotClassName}`}></div>
    </div>
  );
};

export default SectionTitle;
